import { FETCH_DISTRIBUTOR_LIST_ACTION_PENDING, FETCH_DISTRIBUTOR_LIST_ACTION_SUCCESS, FETCH_DISTRIBUTOR_LIST_ACTION_ERROR } from '../action/distributorListAction';

const initialState = {
    
    pending: false,
    distributorList: [],
    error: null
}

const distributorListReducer = (state = initialState, action) => {
   
    switch (action.type) {
        case FETCH_DISTRIBUTOR_LIST_ACTION_PENDING:
            return {
                ...state,
                pending: true,
            }
        case FETCH_DISTRIBUTOR_LIST_ACTION_SUCCESS:
            return {
                ...state,
                pending: false,
                distributorList: action.payload,
              
            }
        case FETCH_DISTRIBUTOR_LIST_ACTION_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
            }
        default:
            return state;
    }
}
export default distributorListReducer;
export const getDistributorProfile = state => state.distributorList;
export const getDistributorProfilePending = state => state.pending;
export const getDistributorProfileError = state => state.error;
